'use client';
import CSRBannerStripWhite from "./csr-banner-stripe-white";
import styles from './bob-banner-white.module.scss';
import { CatButton, CatIconWarningTriangle } from "components/blocks-components";
import RestrictionPopover from "./restrictions/restrictions-popover";
import { bannerTexts } from "../../constants";
import { Method } from "constants/enums";
import {
    getSessionStorage,
    removeSessionStorage
  } from '@cat-ecom/common/utils/storageUtils';
import { IS_GUEST, USER_INACTIVE } from 'constants/storageConstants';
import { Conditional } from "@cat-ecom/pcc-components";
import { useEffect } from "react";
import { MAIN_CAT_HEADER_ID } from "@cat-ecom/pcc-components/src/components/header/constants";
import { ECOMMERCE_DEVELOPMENT_ROOT } from "constants/links";
import { USER_RESET_IN_SESSION } from "constants/endpoints";
interface BobBannerWhite {
    firstName: string;
    lastName: string;
    userTypeText: string;
    restrictions: [string, string, string[]][],
    isTransactingAsGuest: boolean,
    storeId: string
}

export const BobBannerWhite = ({ firstName = "", lastName = "", userTypeText = "", restrictions = [], isTransactingAsGuest, storeId }: BobBannerWhite) => {
    const showRestrictions = restrictions?.length > 0;
    // TODO - Input Validation - Ensure that the value being retrieved will be read as a boolean value
    // Add the type to the const: (const value: 'true' | 'false' = getSessionStorage(sessionValue)) 
    const isGuest = JSON.parse(getSessionStorage(IS_GUEST));

    const onDisconnect = async () => {
      try {
        const url = `${ECOMMERCE_DEVELOPMENT_ROOT}${USER_RESET_IN_SESSION}?storeId=${storeId}`;
        const response = await fetch(url, {
          method: Method.GET,
          headers: {
            credentials: 'include'
          }
        });
        const data = await response.text();
        const redirectionRoute = JSON.parse(
          data.replace('*/', '').replace('/*', '')
        );
        if (redirectionRoute?.url) {
          removeSessionStorage(IS_GUEST);
          window.location.href = redirectionRoute.url;
        }
      } catch (error) {
        console.log('User reset in session failed', error);
        removeSessionStorage(USER_INACTIVE);
      }
    };

    useEffect(() => {
                const catHeader = document.getElementById(MAIN_CAT_HEADER_ID);
                const stickyBanner = document.getElementById('CSRBannerStrip')?.getBoundingClientRect()?.height;
            if(catHeader && stickyBanner){
                catHeader.style.setProperty("top", `${stickyBanner}px`, "important"); 
            }
    }, [])
    
    return (
        <Conditional test={(isGuest && isTransactingAsGuest) || !isTransactingAsGuest}>
            <CSRBannerStripWhite>
                <div className={styles['CSRBannerStrip__user_info']}>
                    <div className={styles['CSRBannerStrip__user_info__name']}>
                        {
                            isTransactingAsGuest ?
                                `${bannerTexts.GUEST_CUSTOMER}`
                                : `${firstName ?? ''} ${lastName ?? ''}`
                        }
                    </div>
                    <div className={styles['CSRBannerStrip__user_info__user_box']}>
                        {showRestrictions && (
                            <RestrictionPopover content={restrictions}>
                                <div
                                    className={
                                        styles['CSRBannerStrip__user_info__user_alert']
                                    }
                                >
                                    <CatIconWarningTriangle
                                        size="sm"
                                        color="error"
                                        slot="before"
                                        data-testid="error-icon"
                                    />
                                    <div className="ms-1">
                                        {bannerTexts.CSR_BANNER_RESTRICTIONS_APPLY}
                                    </div>
                                </div>
                                {!isTransactingAsGuest && (
                                    <div
                                        className={styles['CSRBannerStrip__user_info__devider']}
                                    ></div>
                                )}

                            </RestrictionPopover>
                        )}
                        {!isTransactingAsGuest && (
                            <div
                                className={styles['CSRBannerStrip__user_info__user_type']}
                            >
                                {userTypeText}
                            </div>
                        )}
                    </div>
                </div>
                <CatButton variant="danger" size="sm" onClick={() => onDisconnect()}>
                    <>
                        {
                            !isTransactingAsGuest
                                ? bannerTexts.DISCONNECT_FROM_ACCOUNT_BTN
                                : bannerTexts.DISCONNECT_FROM_CART_BTN
                        }
                    </>
                </CatButton>
            </CSRBannerStripWhite>
        </Conditional>
    );
}